import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { useNotifications } from '../contexts/NotificationsContext';

export const ToastNotification = () => {
    const { notifications, removeNotification } = useNotifications();

    return (
        <ToastContainer>
            {
                notifications.map((t) => (
                    <Toast
                        key={t.id}
                        onClose={() => removeNotification(t.id)}
                        delay={10000}
                        autohide
                        bg={t.variant}
                    >
                        <Toast.Header>
                            <strong>{t.header}</strong>
                        </Toast.Header>
                        <Toast.Body>
                            {t.body}
                        </Toast.Body>
                    </Toast>
                ))
            }
        </ToastContainer>
    )
}
